module.exports = __webpack_public_path__ + "img/ProvincieGelderland.c0fdef55.png";